var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96682 20.4727L3.52271 14.0286C2.82576 13.3275 2.82576 12.1952 3.52271 11.4941L11.6128 3.54038C11.9489 3.20987 12.4015 3.02466 12.873 3.02466H19.3274C20.3202 3.02466 21.1249 3.82944 21.1249 4.82218V11.2582C21.1249 11.7405 20.9311 12.2027 20.5869 12.5406L12.5103 20.4727C12.1732 20.8102 11.7156 20.9999 11.2386 20.9999C10.7615 20.9999 10.304 20.8102 9.96682 20.4727ZM18.7278 7.21891C18.7278 8.21165 17.923 9.01643 16.9303 9.01643C15.9375 9.01643 15.1327 8.21165 15.1327 7.21891C15.1327 6.22616 15.9375 5.42139 16.9303 5.42139C17.923 5.42139 18.7278 6.22616 18.7278 7.21891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.64ff21f93d6940183f4e34b4845ac140.svg";
export { ForwardRef as ReactComponent };